// packages/main-app/src/index.tsx
import { installHidRequestDeviceGuard } from "./utils/connectDevice/installHidRequestDeviceGuard";
import React from "react";
import ReactDOM from "react-dom/client";
import * as ReactNamespace from "react";
import * as ReactDOMLegacy from "react-dom";
import * as ReactRouterDOM from "react-router-dom";
import { initBrandTheme } from "@brand-active";
import {
  restoreStoredCustomPrimaryColors,
  restoreStoredCustomBtnPrimaryTextColors,
  restoreStoredCustomBtnDeputyTextColors,
  restoreStoredCustomTextColors,
} from "@eweadn-qiankun/shared-theme";
import "@eweadn-qiankun/shared-i18n";
import {
  ensureSupportedDevices,
  getActiveBrandId,
  initActiveDriverTab,
} from "@eweadn-qiankun/shared-utils";
import { installDesktopBrandHidDevicesListener } from "@/utils/registerDesktopBrandHidDevices";
import { installExxConnectAnimationListener } from "@/utils/exxConnectAnimation";
import { initDriverWindowFocusTracker } from "@/utils/deviceSessionPresence/driverWindowFocus";
import { getSdkApi } from "./sdkApi/loader";
import {
  runDeviceStorageMigration,
  restoreDeviceSessionToStore,
  isDeviceSessionActive,
} from "@/utils/deviceSession";
import { installWebHidAuthorizationGuard } from "@/utils/connectDevice/webHidAuth";
import { registerProductPicLoader } from "@eweadn-qiankun/shared-components";
import { ensureProductPic } from "@/api/productPics";

registerProductPicLoader({
  ensure: (brand, modelKey, options) =>
    ensureProductPic(brand, modelKey, options),
  getBrand: () => getActiveBrandId().trim().toLowerCase() || "eweadn",
});

installWebHidAuthorizationGuard();
installHidRequestDeviceGuard();
installExxConnectAnimationListener();
initActiveDriverTab();
initDriverWindowFocusTracker();

runDeviceStorageMigration();
if (isDeviceSessionActive()) {
  restoreDeviceSessionToStore();
}

if (typeof window !== "undefined") {
  const w = window as typeof window & {
    React?: typeof ReactNamespace;
    ReactDOM?: typeof ReactDOMLegacy;
    ReactRouterDOM?: typeof ReactRouterDOM;
  };
  w.React = ReactNamespace;
  w.ReactDOM = ReactDOMLegacy;
  w.ReactRouterDOM = ReactRouterDOM;
}

initBrandTheme();
restoreStoredCustomPrimaryColors();
restoreStoredCustomTextColors();
restoreStoredCustomBtnPrimaryTextColors();
restoreStoredCustomBtnDeputyTextColors();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

void ensureSupportedDevices().then(async () => {
  installDesktopBrandHidDevicesListener();
  await getSdkApi();
  const { default: App } = await import("./App");
  root.render(
    <React.StrictMode>
      <ReactRouterDOM.BrowserRouter>
        <App />
      </ReactRouterDOM.BrowserRouter>
    </React.StrictMode>
  );
});
